import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useGetDisplayOptionsClasses } from '~/composables/useGetDisplayOptionsClasses';
import useProductContent from '~/composables/useProductContent/useProductContent';
export default defineComponent({
  name: 'BlockTabsContainerStandard',
  components: {
    BlockExpandableTab: function BlockExpandableTab() {
      return import('~/components/cms/custom/BlockExpandableTab/BlockExpandableTab.vue');
    },
    RenderContent: function RenderContent() {
      return import('~/components/cms/page/RenderContent.vue');
    }
  },
  props: {
    title: String,
    tabs: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabTitle: String,
    displayOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props) {
    var _props$tabs, _props$tabs$, _props$tabs$$fields;
    var advancedTabComponent;
    var currentActiveTab = ref(0);
    var wrapperRef = ref(null);
    var currentClassName = ref(useGetDisplayOptionsClasses((_props$tabs = props.tabs) === null || _props$tabs === void 0 ? void 0 : (_props$tabs$ = _props$tabs[0]) === null || _props$tabs$ === void 0 ? void 0 : (_props$tabs$$fields = _props$tabs$.fields) === null || _props$tabs$$fields === void 0 ? void 0 : _props$tabs$$fields.displayOptions).container);
    var _useProductContent = useProductContent(),
      mapComponentName = _useProductContent.mapComponentName;
    var catchphrase = computed(function () {
      var _props$tabs$currentAc, _props$tabs$currentAc2, _props$tabs$currentAc3, _props$tabs$currentAc4;
      return (_props$tabs$currentAc = props.tabs[currentActiveTab.value]) !== null && _props$tabs$currentAc !== void 0 && (_props$tabs$currentAc2 = _props$tabs$currentAc.fields) !== null && _props$tabs$currentAc2 !== void 0 && _props$tabs$currentAc2.catchphrase ? (_props$tabs$currentAc3 = props.tabs[currentActiveTab.value]) === null || _props$tabs$currentAc3 === void 0 ? void 0 : (_props$tabs$currentAc4 = _props$tabs$currentAc3.fields) === null || _props$tabs$currentAc4 === void 0 ? void 0 : _props$tabs$currentAc4.catchphrase : null;
    });
    var components = computed(function () {
      var tabsContent = props.tabs.map(function (tab) {
        var _tab$fields;
        return tab === null || tab === void 0 ? void 0 : (_tab$fields = tab.fields) === null || _tab$fields === void 0 ? void 0 : _tab$fields.contents;
      });
      return tabsContent.reduce(function (modifiedTabs, tabContent, tabIndex) {
        if (Array.isArray(tabContent)) {
          modifiedTabs.push(mapComponentName(tabContent, {
            tabIndex: tabIndex,
            isInTabContainer: true
          }));
        }
        return modifiedTabs.flat();
      }, []);
    });
    var classes = useGetDisplayOptionsClasses(props.displayOptions);
    var getClassName = function getClassName() {
      var _currentClassName$val, _currentClassName$val2;
      return ((_currentClassName$val = currentClassName.value) === null || _currentClassName$val === void 0 ? void 0 : (_currentClassName$val2 = _currentClassName$val.split(' ')) === null || _currentClassName$val2 === void 0 ? void 0 : _currentClassName$val2[0]) || '';
    };
    onMounted(function () {
      advancedTabComponent = document.getElementById(props.tabTitle) ? document.getElementById(props.tabTitle) : wrapperRef.value;
      if (advancedTabComponent) {
        var className = getClassName();
        if (className) {
          advancedTabComponent.classList.add(className);
        }
        advancedTabComponent.classList.add('is-in-block-tabs-container');
      }
    });
    var setClassesAndActiveTab = function setClassesAndActiveTab(event) {
      if (advancedTabComponent) {
        var className = getClassName();
        if (className) {
          advancedTabComponent.classList.remove(className);
        }
      }
      currentActiveTab.value = event.index;
      currentClassName.value = event.className;
      if (advancedTabComponent) {
        var _className = getClassName();
        if (_className) {
          advancedTabComponent.classList.add(_className);
        }
      }
    };
    var getDataFromTab = function getDataFromTab(tab, type) {
      var _tab$fields$image;
      if (tab.fields) {
        switch (type) {
          case 'title':
            return tab.fields.title;
          case 'img':
            return (_tab$fields$image = tab.fields.image) !== null && _tab$fields$image !== void 0 ? _tab$fields$image : null;
          case 'displayOptions':
            return tab.fields.displayOptions;
          case 'key':
            return tab.sys.id;
        }
      }
      return null;
    };
    return {
      getDataFromTab: getDataFromTab,
      setClassesAndActiveTab: setClassesAndActiveTab,
      currentActiveTab: currentActiveTab,
      currentClassName: currentClassName,
      components: components,
      catchphrase: catchphrase,
      classes: classes,
      wrapperRef: wrapperRef
    };
  }
});